import { chain, map } from 'fp-ts/lib/TaskEither';
import { flow, pipe } from 'fp-ts/lib/function';
import { Type } from '@/entities/todo';
import { detailCodec, listCodec, paginationCountCodec } from '../todo/codec';
import { createAuthorizedGetRequest, decode, decodeVersioned, fetchApi, numericEnum, setQuery } from '../../index';
import { encodeIssueQuery, IssueQuery } from '../issue/v2/query';
import { encodeTodoQuery, TodoQuery } from '@/services/api/resources/todo/query';

const baseUrl = '/v2/todos';
const paginationUrl = `${baseUrl}/pagination`;
const recordUrl = (id: number): string => `${baseUrl}/${id}`;

export const list = (query: IssueQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery({
    ...encodeIssueQuery(query),
    type: numericEnum(Type.Issue),
  })),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const listTodo = (query: TodoQuery) => pipe(
  baseUrl,
  createAuthorizedGetRequest,
  map(setQuery({
    ...encodeTodoQuery(query),
  })),
  chain(fetchApi),
  chain(decode(listCodec)),
);

export const getPaginationForTodo = (query: TodoQuery) => pipe(
  paginationUrl,
  createAuthorizedGetRequest,
  map(setQuery({
    ...encodeTodoQuery({ ...query, lazyPagination: 0 }),
  })),
  chain(fetchApi),
  chain(decode(paginationCountCodec)),
);

export const get = flow(
  recordUrl,
  createAuthorizedGetRequest,
  chain(fetchApi),
  chain(decodeVersioned(detailCodec)),
);
